import React from "react";
import * as Yup from "yup";

import moment from "moment";
import {
  CaseForms,
  CaseMutationType,
  CaseStepperType,
} from "../../../helpers/enums";
import { TranslatedText } from "../../../helpers/helpers";
import {
  getEvictionForMutation,
  READING_DEACTIVATION,
} from "../../../helpers/mutations";
import PrivacyPolicy from "../../common/PrivacyPolicy/PrivacyPolicy";
import CustomLetturaSicuraStep from "../custom-steps/CustomTutelaPerditaInitialStep/CustomLetturaSicuraStep";
// Il model definisce la struttura dei dati
// formId è un identificatore del form
// formField contiene la definizione dei singoli campi
const model = {
  formId: CaseForms.LetturaSicuraDisattiva,
  formField: {
    // codiceCliente: {
    //   name: 'codiceCliente',
    //   label: <TranslatedText i18nKey="cases.lettura_sicura.disattiva.codiceCliente.label" />,
    //   placeholder: <TranslatedText i18nKey="cases.lettura_sicura.disattiva.codiceCliente.placeholder" />,
    //   requiredErrorMsg: <TranslatedText i18nKey='cases.errors.required' />,
    //   type: 'input',
    // },
    contractId: {
      name: "contractId",
      label: (
        <TranslatedText i18nKey="cases.lettura_sicura.disattiva.codiceContratto.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.lettura_sicura.disattiva.codiceContratto.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
  },
};

const {
  formField: {
    //codiceCliente,
    contractId,
  },
} = model;

// initialValues contiene i valori iniziali del form, ne imposta anche i campi.
// Si può usare per popolare il form eventualmente.
const initialValues = {
  //  [codiceCliente.name]: '',
  [contractId.name]: "",
  deactivationData: moment().format("YYYY-MM-DD"),
};

// Per definire il validationSchema si usa un array di shape che indicano gli step.
// L'ordine degli step deve corrispondere a quello in layout.

const getValidationSchema = () => {
  // const validationFiscalCode = getValidationRule('fiscalCode');
  // console.log(validationFiscalCode);
  return [
    Yup.object().shape({
      //[codiceCliente.name]: Yup.string().required(codiceCliente.requiredErrorMsg),
      [contractId.name]: Yup.string().required(contractId.requiredErrorMsg),
    }),
  ];
};

// Il layout contiene informazioni di testo e di distribuzione sulle griglie
const getLayout = (privacyLink, privacyCtaLabel) => {
  return [
    {
      chapter: true,
      chapterName: "Lettura sicura",
      title: "",
      component: CustomLetturaSicuraStep,
      // fields: [
      //   // {
      //   //   fieldName: codiceCliente.name,
      //   //   grid: {
      //   //     xs: 12,
      //   //     md: 6,
      //   //   },
      //   // },
      //   {
      //     fieldName: contractId.name,
      //     grid: {
      //       xs: 12,
      //       md: 6,
      //     },
      //   },
      // ],
      content: (
        <div>
          <p>
            <PrivacyPolicy
              privacyLink={privacyLink}
              privacyCtaLabel={privacyCtaLabel}
            />
          </p>
        </div>
      ),
    },
  ];
};

// Contiene dettagli sul case form
const formDetails = {
  title: <TranslatedText i18nKey="cases.lettura_sicura.title" />,
  description: null,
  ssummary: false,
  stepper: CaseStepperType.None,
  formOnly: true,

  helpText: null,
  successText: (
    <div>
      <p>
        <TranslatedText i18nKey="cases.request_info.success_text" />
      </p>
    </div>
  ),
};

const mutation = {
  type: CaseMutationType.Custom,
  mutation: READING_DEACTIVATION,
  refetchQueries: getEvictionForMutation("safeReadingDeactivation"),
};
const getTrackingEventKo = () => () => {
  window.dataLayer.push({
    event: "pratica",
    tipo: CaseForms.LetturaSicuraDisattiva,
    step: "invio_richiesta",
    esito: "KO",
  });
};
const getTrackingEvent = () => () => {
  window.dataLayer.push({
    event: "pratica",
    tipo: CaseForms.LetturaSicuraDisattiva,
    step: "invio_richiesta",
    esito: "OK",
  });
};
const main = (
  excludeSteps,
  counter,
  signDigital,
  webviewPopup,
  webviewRedirectPopup,
  buttonMatricolaContatoreCase,
  privacyLink,
  privacyCtaLabel
) => {
  const layout = getLayout(privacyLink, privacyCtaLabel);
  return {
    model,
    trackingEventKo: getTrackingEventKo(),
    trackingEvent: getTrackingEvent(),
    validationSchema: getValidationSchema(),
    initialValues,
    layout,
    formDetails,
    mutation,
  };
};

export default main;
